import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-abe08cd8")

_pushScopeId("data-v-abe08cd8")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Indicators and signals")
const _hoisted_2 = { class: "px-16" }
const _hoisted_3 = { class: "df-middle my-16" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: "/img/membership/cover_pro.jpg",
  width: "64",
  height: "64",
  style: {"object-fit":"fill"}
}, null, -1)
const _hoisted_5 = { class: "flex-1 ml-16" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Trend Pro")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" See the ups and downs of the trend and overbought/oversold areas intuitively ")
const _hoisted_8 = {
  key: 0,
  class: "text f-nm c-text px-16 pt-12 pb-24"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: "/img/membership/content_pro.jpg",
  style: {"margin-top":"0"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Line = _resolveComponent("Line")
  const _component_Tab = _resolveComponent("Tab")
  const _component_TheSignals = _resolveComponent("TheSignals")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "indicatorsandsignals_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_t, {
              as: "p",
              path: "indicatorsandsignals_17",
              class: "f-lg f-bold mb-8"
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "indicatorsandsignals_18",
              class: "f-sm",
              style: {"line-height":"16px"}
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_Line, { class: "mb-12" })
      ]),
      _createVNode(_component_t, { custom: "" }, {
        default: _withId(({td, t}) => [
          _createVNode(_component_Tab, {
            tabs: [t('indicatorsandsignals_3') || 'Deacription', t('indicatorsandsignals_4') || 'Signals'],
            class: "signal-page-tab px-16",
            onSwitch: _ctx.switchTab,
            active: _ctx.tabIndex
          }, null, 8, ["tabs", "onSwitch", "active"])
        ]),
        _: 1
      }),
      (_ctx.tabIndex === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_t, {
              path: "indicatorsandsignals_19",
              multiline: "",
              custom: ""
            }, {
              default: _withId(({td}) => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
                  return (_openBlock(), _createBlock("p", { key: index }, _toDisplayString(p), 1))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(_component_TheSignals, {
            key: 1,
            class: "pt-12 pb-24"
          }))
    ]),
    _: 1
  }))
})